module.exports = __webpack_public_path__ + "img/top9-left.9de99b4b.png";